module.exports = {
          srcSet: __webpack_public_path__ + "92aecbbbf72f70f7d6cb3dafadd22908-180.jpg"+" 180w",
          images:[ {path: __webpack_public_path__ + "92aecbbbf72f70f7d6cb3dafadd22908-180.jpg",width: 180,height: 180}],
          src: __webpack_public_path__ + "92aecbbbf72f70f7d6cb3dafadd22908-180.jpg",
          toString:function(){return __webpack_public_path__ + "92aecbbbf72f70f7d6cb3dafadd22908-180.jpg"},
          
          width: 180,
          height: 180
        }